'use strict';
import DataQueryList from './mx-data-query-list.js';

angular.module('mx.SolutionBuilderAgent').component('mxContentWidgetViewCalendar', {
	transclude: true,
	bindings: { parameters: '=' },
	controller: MxContentWidgetViewCalendarCtrl,
	controllerAs: 'vm',
	templateUrl: 'workspaces/SolutionBuilderAgent/components/mx-content-widget-view/list/mx-content-widget-view-calendar.html',
});

MxContentWidgetViewCalendarCtrl.$inject = [
	'$injector',
	'$scope',
	'mx.SolutionBuilderAgent.DialogOpenerService',
	'mx.internationalization',
	'mx.shell.EventService',
	'mx.shell.SearchProviderService',
	'mx.SolutionBuilderAgent.Http',
	'mx.SolutionBuilderAgent.PersonalizationService',
	'$timeout',
	'$q',
	'mx.shell.ActionManagerService',
	'mx.shell.ActionExecutorService',
	'mx.SolutionBuilderAgent.DateRangePreprocessor',
	'mx.SolutionBuilderAgent.SearchPreprocessor',
	'mx.SolutionBuilderAgent.GroupingPreprocessor',
	'mx.SolutionBuilderAgent.StructurePreprocessor',
];

MxContentWidgetViewCalendarCtrl.prototype = Object.create(DataQueryList.prototype);

function MxContentWidgetViewCalendarCtrl(
	$injector,
	$scope,
	dialogOpener,
	i18n,
	eventService,
	searchService,
	http,
	personalizationService,
	$timeout,
	$q,
	actionManagerService,
	actionExecutorService,
	DateRangePreprocessor,
	SearchPreprocessor,
	GroupingPreprocessor,
	StructurePreprocessor
) {
	var vm = this;
	var personalizedParams = {};
	vm.calendarReinit = false;

	vm.$onInit = function () {
		vm.type = mx.SolutionBuilderAgent.ListingType.calendar;
		vm.businessHours = true;
		vm.items = [];
		vm.langCode = i18n.language;
		vm.startDate = undefined;
		vm.endDate = undefined;
		vm._inited = false;
		vm.dropdownMenuOptions = {};
		vm.readonlyKey = vm.parameters.calendar.readonlyKey || '_readonly';

		vm.itemsLoader = itemsLoader;
		vm.editMovedItem = editMovedItem;
		vm.rangeSelectionHandler = rangeSelectionHandler;

		$q.all([personalizationService.getCalendarSettings(vm.parameters.id), actionManagerService.getCreateActions(vm.parameters.entityTypes[0])]).then(function (data) {
			var settings = data[0] || {},
				createActions = data[1];

			vm.isCreateEnabled = Array.isArray(createActions) && createActions.length > 0;

			if (settings.calendarView) {
				vm.parameters.calendar.defaultView = settings.calendarView;
			}

			personalizedParams = settings;
			personalizedParams.extraDimensionValuesVisibility = personalizedParams.extraDimensionValuesVisibility || {};
			tryInitGroupingSettings(personalizedParams);

			vm.initialize($injector, $scope, [DateRangePreprocessor, SearchPreprocessor, GroupingPreprocessor, StructurePreprocessor]);

			vm.calendarReinit = true;
		});
	};

	$scope.$watch('vm.data', function (data) {
		if (Array.isArray(data)) {
			vm.items = data;

			if (vm.parameters.calendar.calendarExtraDimensionRelation) {
				_prepareExtraDimension();
				var newExtraDimensions = getVisibleExtraDimensions();

				if (!mx.components.Utils.arraysEqual(newExtraDimensions, vm.parameters.calendar.extraDimensions, dimensionEqualityFunction)) {
					vm.parameters.calendar.extraDimensions = newExtraDimensions;
				}
			}
		}
	});

	vm.$onDestroy = function () {
		DataQueryList.prototype.$onDestroy.call(this);
		delete vm.parameters.calendar._doGrouping;
		delete vm.parameters.calendar.extraDimensions;
		delete vm.parameters.calendar.allExtraDimensions;
	};

	return vm;

	function markItemsWithoutEditAction(items) {
		if (!Array.isArray(items)) {
			return $q.when([]);
		}
		return $q
			.all(
				items.map(function (item) {
					return actionManagerService.getEditActions(item).then(function (editActions) {
						item[vm.readonlyKey] = item[vm.readonlyKey] || editActions.length === 0;
					});
				})
			)
			.then(function () {
				return items;
			});
	}

	function dimensionEqualityFunction(dimension1, dimension2) {
		return dimension1.id === dimension2.id;
	}

	function tryInitGroupingSettings(personalizedParams) {
		var params = vm.parameters.calendar;
		var storedIfGroupByExtra = personalizedParams.groupByExtraDimension;

		// Do grouping if extra dimension is set
		params._doGrouping = !!params.calendarExtraDimensionRelation;

		var _showUnassigned;
		if (!vm.parameters.calendar.hasOwnProperty('showUnassigned')) {
			Object.defineProperty(vm.parameters.calendar, 'showUnassigned', {
				get: function () {
					return _showUnassigned;
				},
				set: function (isVisible) {
					_showUnassigned = isVisible;
					if (personalizedParams.showUnassigned !== _showUnassigned) {
						personalizedParams.showUnassigned = _showUnassigned;
						personalizationService.saveCalendarSettings(vm.parameters.id, personalizedParams);
					}
				},
			});
		}

		_showUnassigned = typeof personalizedParams.showUnassigned === 'undefined' ? true : personalizedParams.showUnassigned;

		if (params._doGrouping && !params.groupByDimensionValue) {
			params.extraDimensionKey = params.calendarExtraDimensionRelation + '_Value';

			if (storedIfGroupByExtra || (storedIfGroupByExtra === undefined && params.groupByExtraDimension)) {
				params._groupByDimensionValue = 'extra';
			} else {
				params._groupByDimensionValue = 'default';
				params.isTimeline = true;
			}

			Object.defineProperty(params, 'groupByDimensionValue', {
				get: function () {
					return params._groupByDimensionValue;
				},
				set: function (newVal) {
					var groupByExtraDimension = newVal === 'extra';
					params._groupByDimensionValue = newVal;
					params.isTimeline = !groupByExtraDimension;
					params.showUnassigned = groupByExtraDimension;
					personalizedParams.groupByExtraDimension = groupByExtraDimension;
					personalizationService.saveCalendarSettings(vm.parameters.id, personalizedParams);
					_prepareExtraDimension();
					params.extraDimensions = getVisibleExtraDimensions();

					vm.calendarReinit = false;
					$timeout(function () {
						vm.calendarReinit = true;
					}, 200);
				},
			});

			var promise;
			if (vm.parameters.entities.length === 1) {
				promise = $q.when(vm.parameters.entities[0].displayName);
			} else {
				promise = vm.parameters.dataQuery.getRecordTypeDisplayString();
			}

			promise.then(function (recordDisplayName) {
				params._groupByDimensionArr = [
					{
						name: 'default',
						title: recordDisplayName,
					},
					{
						name: 'extra',
						title: _getColumnExtraDimensionTitle(),
					},
				];
			});
		}
	}

	function _getColumnExtraDimensionTitle() {
		var relation = vm.parameters.calendar.calendarExtraDimensionRelation;
		return (
			vm.parameters.dataQuery.Columns.find(function (it) {
				return it.Name === relation;
			}).Title || relation
		);
	}

	function itemsLoader(options) {
		var start = options.start,
			end = options.end;

		// Not in range of last loads
		if (vm._inited && (start.toDate() < new Date(vm.lastLoadedStartDate) || end.toDate() > new Date(vm.lastLoadedEndDate))) {
			vm.lastLoadedStartDate = start.toISOString();
			vm.lastLoadedEndDate = end.toISOString();
			vm.parameters.data = undefined;
		}

		vm.dateRangePreprocessor.startDate = start.toISOString();
		vm.dateRangePreprocessor.endDate = end.toISOString();

		updateBusinessHours(options.currentDate, options.calendarView);

		if (!vm._inited) {
			vm.lastLoadedStartDate = vm.dateRangePreprocessor.startDate;
			vm.lastLoadedEndDate = vm.dateRangePreprocessor.endDate;
			vm._inited = true;

			return vm.load().then(function () {
				return markItemsWithoutEditAction(vm.data);
			});
		} else {
			return vm.reload().then(function () {
				return markItemsWithoutEditAction(vm.data);
			});
		}
	}

	function rangeSelectionHandler(options) {
		// Disable calendar for the editing period
		vm.calendarDisabled = true;
		var presetFields = _formPresetFields(options);
		var actionExecutedPromise = actionExecutorService.executeCreateAction(vm.parameters.entityTypes[0], undefined, presetFields);
		actionExecutedPromise.finally(function () {
			vm.calendarDisabled = false;
		});

		return actionExecutedPromise;
	}

	function editMovedItem(options) {
		vm.calendarDisabled = true;
		var presetFields = _formPresetFields(options);
		var actionExecutedPromise = actionExecutorService.executeEditAction(options.item, undefined, presetFields);

		actionExecutedPromise.finally(function () {
			vm.calendarDisabled = false;
		});

		return actionExecutedPromise;
	}

	function _prepareExtraDimension() {
		var extraDimensionArr = [];

		var data = vm.items;

		var relationKey = vm.parameters.calendar.calendarExtraDimensionRelation;
		var relationValueKey = vm.parameters.calendar.calendarExtraDimensionRelation + '_Value';
		var relationColumn = vm.parameters.dataQuery.Columns.find(function (column) {
			return column.Name === relationKey;
		});

		if (!Array.isArray(data) || !data.length) {
			extraDimensionArr = [];
		} else {
			var ids = {};

			extraDimensionArr = data
				.filter(function onlyUnique(item) {
					if (item[relationValueKey] && !ids[item[relationValueKey]]) {
						ids[item[relationValueKey]] = true;
						return true;
					}
				})
				.map(function (item) {
					var newExtraDimensionValue = {
						id: item[relationValueKey],
						title: item[relationKey],
						image: item[vm.parameters.calendar.calendarExtraDimensionImageColumn],
						referenceTo: relationColumn && relationColumn.ReferenceTo,
						_visible: personalizedParams.extraDimensionValuesVisibility[item[relationValueKey]] !== false,
					};
					Object.defineProperty(newExtraDimensionValue, 'visible', {
						get: function () {
							return this._visible;
						},
						set: function (isVisible) {
							this._visible = isVisible;
							personalizedParams.extraDimensionValuesVisibility[this.id] = isVisible;
							personalizationService.saveCalendarSettings(vm.parameters.id, personalizedParams);

							vm.parameters.calendar.extraDimensions = getVisibleExtraDimensions();
						},
					});

					return newExtraDimensionValue;
				});
		}

		extraDimensionArr.sort(function (first, second) {
			var firstTitle = first.title || '';
			var secondTitle = second.title || '';
			return firstTitle.localeCompare(secondTitle, undefined, { sensitivity: 'accent' });
		});

		vm.parameters.calendar.allExtraDimensions = extraDimensionArr;
	}

	function getVisibleExtraDimensions() {
		return vm.parameters.calendar.allExtraDimensions.filter(function (dimension) {
			return dimension.visible;
		});
	}

	function _applyPresetFieldByPath(presetFields, path, value) {
		var presetStep = (presetFields = presetFields || {});
		path.forEach(function (pathStep, index, array) {
			if (index < array.length - 1) {
				presetStep[pathStep] = presetStep[pathStep] || {};
				presetStep = presetStep[pathStep];
			} else {
				presetStep[pathStep] = value;
			}
		});
	}

	function _applyPresetFieldByColumn(presetFields, columnName, value) {
		var path = vm.parameters.dataQuery.getPropertyPath(columnName);
		if (!Array.isArray(path) || path.length < 1) {
			return;
		}
		_applyPresetFieldByPath(presetFields, path, value);
	}

	function _formPresetFields(options) {
		var presetFields = {};

		if (vm.parameters.calendar.startDateKey) {
			_applyPresetFieldByColumn(presetFields, vm.parameters.calendar.startDateKey, options.start);
		}

		if (vm.parameters.calendar.endDateKey) {
			_applyPresetFieldByColumn(presetFields, vm.parameters.calendar.endDateKey, options.end);
		}

		if (vm.parameters.calendar.wholeDayKey) {
			_applyPresetFieldByColumn(presetFields, vm.parameters.calendar.wholeDayKey, Boolean(options.wholeDay));
		}

		if (vm.parameters.calendar.calendarExtraDimensionRelation) {
			_applyPresetFieldByColumn(presetFields, vm.parameters.calendar.calendarExtraDimensionRelation, options.dimensionId);
		}

		return presetFields;
	}

	function getBusinessHours(date) {
		return http.get('api/calendar/workingHours' + '?year=' + date.year() + '&week=' + date.week(), undefined, { cache: true }).then(function (resBusinessHours) {
			// Move `Sunday` as 7th day
			resBusinessHours.push(resBusinessHours.shift());

			return resBusinessHours
				.map(function (day, i) {
					return {
						dow: [i + 1],
						start: day.WorkingTimeStart,
						end: day.WorkingTimeEnd,
						isWorkingDay: day.IsWorkingDay,
					};
				})
				.filter(function (day) {
					return day.isWorkingDay;
				});
		});
	}

	function updateBusinessHours(currentDate, calendarView) {
		if (['week', 'day'].indexOf(calendarView) !== -1) {
			var year = currentDate.year();
			var week = currentDate.week();

			if (year === vm.previousBussinessYear && week === vm.previousBussinessWeek) {
				return $q.when();
			}
			vm.previousBussinessWeek = week;
			vm.previousBussinessYear = year;

			return getBusinessHours(currentDate).then(function (businessHours) {
				if (!angular.equals(vm.businessHours, businessHours)) {
					vm.businessHours = businessHours;
				}
			});
		} else {
			// If not Week or Day modes (e.g. for Month mode) then just show default business hours
			vm.businessHours = true;
			return $q.when();
		}
	}
}

export default MxContentWidgetViewCalendarCtrl;
